/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Presentation subtotal for an additional cost category at the order level, provided by the pricing engine. This is a display-oriented projection rather than a new cost, showing a summarized view such as a total handling fee or total delivery cost that the pricing provider chooses to surface for storefront rendering. Order data already has a single final total; these entries are subtotals within it.
 * @export
 * @interface SAPAdditionalTotal
 */
export interface SAPAdditionalTotal {
    /**
     * Additional total type, for example PRODUCT_TOTAL_PLAIN or ADDITIONAL_COSTS_TOTAL_PLAIN.
     * @type {string}
     * @memberof SAPAdditionalTotal
     */
    type?: string;
    /**
     * Total amount.
     * @type {number}
     * @memberof SAPAdditionalTotal
     */
    amount?: number;
    /**
     * Internationalization key for the description of this additional total, intended for storefront rendering.
     * @type {string}
     * @memberof SAPAdditionalTotal
     */
    descriptionKey?: string;
}

/**
 * Check if a given object implements the SAPAdditionalTotal interface.
 */
export function instanceOfSAPAdditionalTotal(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SAPAdditionalTotalFromJSON(json: any): SAPAdditionalTotal {
    return SAPAdditionalTotalFromJSONTyped(json, false);
}

export function SAPAdditionalTotalFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAPAdditionalTotal {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'descriptionKey': !exists(json, 'descriptionKey') ? undefined : json['descriptionKey'],
    };
}

export function SAPAdditionalTotalToJSON(value?: SAPAdditionalTotal | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'amount': value.amount,
        'descriptionKey': value.descriptionKey,
    };
}

